import React from 'react';
import { useI18n } from '@udemy/i18n';
import { CardAuthors } from '@udemy/react-product-card-components';
import { safelySetInnerHTML } from '@udemy/shared-utils';
/**
 * ### CourseCardInstructors
 *
 * Renders the instructors for a course for the `CourseProductCard` `authors` prop
 * from a `Course` object
 */
export const CourseCardInstructors = ({
  course
}) => {
  var _course$visible_instr;
  const {
    ngettext
  } = useI18n();
  const displayNames = (_course$visible_instr = course === null || course === void 0 ? void 0 : course.visible_instructors.map(({
    display_name
  }) => display_name)) !== null && _course$visible_instr !== void 0 ? _course$visible_instr : [];
  if (displayNames.length) {
    return /*#__PURE__*/React.createElement(CardAuthors, {
      label: ngettext('Instructor:', 'Instructors:', displayNames.length),
      authors: /*#__PURE__*/React.createElement("span", safelySetInnerHTML({
        descriptionOfCaller: 'course-card:visible-instructors',
        html: displayNames.join(', ')
      }))
    });
  }
  return null;
};
//# sourceMappingURL=course-card-instructors.react-component.js.map